// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__26Yjo","row":"styles_row__NMAsp"};